import { images } from "@/assets";
import { routes } from "@/routes/utils";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const useReportSection = () => {
  const navigate = useNavigate();
  const [reportCards] = useState<any>([
    {
      title: (
        <span>
          Invoice
          <br />
          360 Report
        </span>
      ),
      link: routes.reports,
      icon: images.invoice_report,
    },
    {
      title: (
        <span>
          Payment
          <br />
          360 Report
        </span>
      ),
      link: `${routes.payment}/${routes.reports}`,
      icon: images.payment_report,
    },
    {
      title: (
        <span>
          Tolerance
          <br />
          Report
        </span>
      ),
      link: `${routes.payment}/${routes.tolerance}`,
      icon: images.tolerance,
    },
  ]);

  const [collectionReportCards] = useState<any>([
    {
      title: (
        <span>
          Collection 360
          <br />
          Report
        </span>
      ),
      link: routes.ar360,
      icon: images.ar_360_report,
    },
  ]);

  const onReportCardClick = (link: any) => () => {
    link ? navigate(link) : "";
  };

  return {
    onReportCardClick,
    reportCards,
    collectionReportCards,
  };
};

export default useReportSection;
